export default "__VITE_ASSET__27886874__"